import { formatTime as baseFormatTime } from '@chatwoot/utils';

// @chatwoot/utils.formatTime отдаёт англоязычные единицы времени
// (например «5 Min», «2 Hrs», «10 Sec», «3 Days»). В русскоязычных
// отчётах локализуем их, сохраняя исходную логику форматирования.
export const formatTime = timeInSeconds =>
  String(baseFormatTime(timeInSeconds) ?? '')
    .replace(/\bSec\b/g, 'сек')
    .replace(/\bMin\b/g, 'мин')
    .replace(/\bHrs?\b/g, 'ч')
    .replace(/\bDays?\b/g, 'дн');
